import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import companyNameReducer from './companyName/data/reducer';
import companyNameSaga from './companyName/data/sagas';
import conformanceLanguageReducer from './conformanceLanguage/data/reducer';
import conformanceLanguageSaga, {
  initSaga as conformanceLanguageInitSaga,
} from './conformanceLanguage/data/sagas';
import downloadCuiAuditCsvDrawerReducer from './cuiAudit/downloadCuiAuditCsvDrawer/data/reducer';
import customPartAttrsReducer from './customPartAttrs/data/reducer';
import customPartAttrsSaga, {
  initSaga as customPartAttrsInitSaga,
} from './customPartAttrs/data/sagas';
import emailNotificationsReducer from './emailNotifications/data/reducer';
import emailNotificationsSaga, {
  initSaga as emailNotificationsInitSaga,
} from './emailNotifications/data/sagas';
import shopVariablesReducer from './shopVariables/data/reducer';
import shopVariablesSaga, {
  initSaga as shopVariablesInitSaga,
} from './shopVariables/data/sagas';
import * as supplierFacilities from './supplierFacilities/index';

const initSaga = function* () {
  yield all([
    conformanceLanguageInitSaga(),
    customPartAttrsInitSaga(),
    emailNotificationsInitSaga(),
    shopVariablesInitSaga(),
    supplierFacilities.initSaga(),
  ]);
};

const reducer = combineReducers({
  companyName: companyNameReducer,
  conformanceLanguage: conformanceLanguageReducer,
  customPartAttrs: customPartAttrsReducer,
  downloadCuiAuditCsvDrawer: downloadCuiAuditCsvDrawerReducer,
  emailNotifications: emailNotificationsReducer,
  shopVariables: shopVariablesReducer,
  supplierFacilities: supplierFacilities.reducer,
});

const saga = function* () {
  yield all([
    companyNameSaga(),
    conformanceLanguageSaga(),
    customPartAttrsSaga(),
    emailNotificationsSaga(),
    shopVariablesSaga(),
    supplierFacilities.saga(),
  ]);
};

export { initSaga, reducer, saga };
